import styled from "styled-components";
import { ICardStyled } from "./interface";


export const WrapContext = styled.div`
  display: flex;
  width: 100%;
  overflow-y: scroll;
  height: 90vh;
`;

export const Card =styled.div<ICardStyled>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    width: calc(100% - 2px);
    min-height: 70px;

    margin: 8px 2px;
    padding-left: 8px;

    box-shadow: rgb(0 0 0 / 16%) 0px 1.5px 3px, rgb(0 0 0 / 23%) 0px 1.5px 3px;
    background: ${(props) => props.selected ? "var(--main-color)" : "var(--card-background)"};
    
    position: relative;
    cursor: pointer;

    border-radius: 4px;

    transition: 200ms ease;

    &:hover{
        background: ${(props) => props.selected ? "var(--purple-darker)" : "var(--border-color)"};
    }

    .card-body{
        font-weight: bold;
        color: ${(props) => props.selected ? "white" : "unset"};
        overflow: hidden;
        width: 95%;

        span{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }

    .card-footer{
        font-size: 0.7rem;
        color: ${(props) => props.selected ? "white" : "unset"};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .icon-options{
        position: absolute;
        top: -4px;
        right: -8px;
    }

    .icon-favorite{
        position: absolute;
        top: 3px;
        left: 5px;
    }

    border-left: 4px solid ${(props) => props.color ?? "white"};
`;

export const SidebarCardBody = styled.div`
    width: calc(100% - 20px);
    min-height: 70px;
    display: flex;
    align-items: center;
`;


export const ContainerAccordion = styled.div`
    .MuiButtonBase-root{
        height: 100%;
    }

    .accordion-program{
        .MuiAccordionDetails-root{
            padding:10px;
            padding-right: 0px;
        }

        .MuiCollapse-wrapper{
            border:none;
        }
    }

    .accordion-businessModel{
        width: 100%;
        box-shadow: none;

        .MuiCollapse-wrapper{
            border:none;
        }

        .MuiAccordion-root{
            box-shadow: none;
        }

        .MuiButtonBase-root{
            height: 30px;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root{
            background: #9e9e9e30;

            @media(max-width: 600px){
                height: 150px;
            }

            .MuiAccordionSummary-content{
                @media(max-width: 600px){
                    height: 133px;
                }
            }
        }

        .list-component-child{
            background: transparent !important;
            background-color: transparent !important;
            border: none;
            box-shadow: none;
            height: 30px;

            div{
                overflow: visible !important;
            }
        }

        .list-component-child:hover{
            background: transparent !important;
            background-color: transparent !important;
            border: none;
            box-shadow: none !important;
        }

        .ccxyYC{
            margin: 0px;
        }
    }

    .accordion-answer{
        width: 100%;

        .MuiCollapse-wrapper{
            border:none;
        }

        .isxWuD:hover.li.list-component-child:hover{
            box-shadow: none;
        }

        .MuiButtonBase-root.MuiAccordionSummary-root{
            background: #9e9e9e14;
        }

        .MuiAccordionDetails-root{
            .MuiCollapse-wrapper{
                padding: 0px 10px 0px 10px;
            }
        }
    }

    .container-actions{
        width: 100%;
        .list-component-child{
            height: 100%;
            border-bottom: 1px solid var(--border-color);
            box-shadow: 0 2px 1px -1px var(--border-color);
        }

        .list-component-child:hover{
            height: 100%;
            border-bottom: 1px solid var(--border-color);
            box-shadow: 0 2px 1px -1px var(--border-color);
        }
    }

    ul.ul-businessModel-head{
        width: 100%;
    }

    li.businessModel-head{
        border-top: 1px solid var(--border-color);
        border-bottom: 1px solid var(--border-color);
        background: var(--li-header-color);
        color: var(--default-color-font);
        padding: 4px;
        margin: 5px 0;
        font-size: 0.9rem;
        font-weight: bold;

        @media(max-width: 600px){
            display: none;
        }        
    }

    .head-title{
            display: block;

            @media(max-width: 971px){
                background-color: blue;
                display: none;
            }
        }
`;

export const Ulcontainer = styled.ul`
		display: flex;
		width: 100%;
		flex-direction: column;
		transition: 150ms ease;

        .caEBVP{
            align-items: baseline;
        }

		li.list-component-child{
			display: flex;
			flex-direction: row;
			position: relative;

			align-items: center;

			border-radius: 10px;
			border: 1px solid var(--border-color);
			box-shadow: 0 2px 1px -1px var(--border-color);
			background: var(--card-background);
			color: var(--default-color-font);

			font-size: 0.83rem;

			padding: 4px;
			margin: 5px 0;

			transition: 150ms ease;


			@media(max-width: 600px){
				flex-direction: column;
			}

			&.is-children{
				margin-bottom: 0.5rem;
				padding: 0;
				padding-left: 4px;
				border-bottom: none;
			}
		}

		li.list-component-header{
			display: flex;
			flex-direction: row;

			border-bottom: 1px solid var(--border-color);

			font-size: 0.9rem;

			padding: 4px;
			margin: 5px 0;

			position: sticky;
			top: 0;
			background: var(--input-background-color);
			color: var(--default-color-font);
			z-index: 2;
      font-weight: bold;
      
      @media(max-width: 600px){
        display: none;
      }
		}

		&:hover{
			li.list-component-child{
				box-shadow: none;
				&:hover{
					box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 8px;
				}
			}
		}
`;
 
